// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheet-Scrim_cls1__QbzwA","cls2":"VeloModalSheet-Scrim_cls2__UJkCs VeloModalSheet-Scrim_cls1__QbzwA"};